import { FormControl } from '../../../components/FormUtilities'
import InputField from '../../../components/InputField'
import { formCategory } from '../storage'

export default function Form() {
    const { props, getError } = formCategory.useInput('name')
    const helper = getError(
        'ERROR-0000102',
        'Ya existe una categoría con el mismo nombre'
    )
    return (
        <FormControl label="Nombre de categoría" required>
            <InputField
                placeholder="Ingresar nombre"
                autoFocus
                {...props}
                helper={helper || props.helper}
            />
        </FormControl>
    )
}
